// extracted by mini-css-extract-plugin
export var askAiIcon = "_p6-k";
export var category = "_p6-a";
export var categoryHeader = "_p6-f";
export var container = "_p6-0";
export var group = "_p6-b";
export var groupItems = "_p6-g";
export var groupSeparator = "_p6-l";
export var highlight = "_p6-8";
export var loading = "_p6-1";
export var noResults = "_p6-3";
export var placeholder = "_p6-2";
export var resultContent = "_p6-5";
export var resultIcon = "_p6-d";
export var resultItem = "_p6-h";
export var resultMeta = "_p6-9";
export var resultSubtitle = "_p6-7";
export var resultSuffix = "_p6-j";
export var resultTitle = "_p6-6";
export var resultsList = "_p6-4";
export var searchGroup = "_p6-e";
export var selected = "_p6-i";
export var subgroup = "_p6-c";